<template>
  <div class="workouts-slider-wrapper section-padding">
    <div class="container" v-if="showWorkshopSlider">
      <div class="workouts-slider-holder">
        <div class="workouts-slider-heading d-flex justify-content-between align-items-center">
          <p class="section-title">Workshops</p>
          <div class="d-flex justify-content-end align-items-center">
            <router-link to="/workshop-list" class="heading-link">Ver todos</router-link>
            <div class="workouts-slider-arrows d-none d-xl-flex align-items-center justify-content-center">
              <button type="button" class="workouts-slider-arrow workouts-slider-prev" @click="prevSlide">
                <chevronLeft/>
              </button>
              <button type="button" class="workouts-slider-arrow workouts-slider-next" @click="nextSlide">
                <chevronLeft/>
              </button>
            </div>
          </div>
        </div>
        <Slick ref="slick" :options="slickOptions" class="workouts-slider">
          <div class="workouts-slider-item" v-for="(item,index) in workshopSliderItems" :key="index">
            <workshopItem :workshopItem="item"/>
          </div>
        </Slick>
      </div>
    </div>
  </div>
</template>

<script>
import Slick from 'vue-slick';
import workshopItem from "@/components/workshop/workshop-item.vue";
import chevronLeft from "@/components/svg/chevron-left.vue";
import axios from 'axios';

export default {
  name: "workshop-slider",
  components : {
    Slick,
    workshopItem,
    chevronLeft
  },
  data() {
    return {
      lang: this.$root.siteLang,
      workshopSliderItems: [],
      showWorkshopSlider: false,
      slickOptions: {
        slidesToScroll: 1,
        pauseOnHover: true,
        autoplay: true,
        arrows: false,
        dots: false,
        infinite: true,
        swipeToSlide: true,
        touchMove: true,
        speed: 1000,
        variableWidth: true,
        lazyLoad: 'ondemand',
      }
    }
  },
  methods: {
    prevSlide: function() {
      this.$refs.slick.prev();
    },
    nextSlide: function() {
      this.$refs.slick.next();
    },
  },
  created() {

    let authKey = window.$cookies.get("authKey");

    axios
        .get(process.env.VUE_APP_API_URL + 'products?id_category=2&with_category_title=0&lang=' + this.lang,{
          headers: {
            Authorization: 'Bearer ' + authKey
          }
        })
        .then((response) => {
          this.workshopSliderItems = response.data;
        })
        .catch((e) => {
          this.errors.push(e);
        }).finally((e) => {
      (this.workshopSliderItems.length > 0) ? this.showWorkshopSlider = true : this.showWorkshopSlider = false;
    });
  },
}
</script>